import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployerBusinesses } from 'scenes/Settings/FormEditor/store/slices/formEditorSlice';
import { SuggestionFieldChatbot } from './SuggestionFieldChatbot/SuggestionFieldChatbot';
import { getEmployerBusinessesThunk } from 'scenes/Settings/FormEditor/store/thunks/formEditorThunks';

export const ConfirmChatbotLicenceForm = ({
  newBusinessId,
  setNewBusinessId,
  businessName,
  setNewBusinessName,
}) => {
  const dispatch = useDispatch();

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredBusinesses, setFilteredBusinesses] = useState([]);

  const businesses = useSelector(getEmployerBusinesses);

  useEffect(() => {
    dispatch(getEmployerBusinessesThunk());
  }, []);

  useEffect(() => {
    if (newBusinessId.trim() && businesses?.length > 0) {
      const filtered = businesses.filter((business) =>
        business.business_id
          ?.toLowerCase()
          .includes(newBusinessId.toLowerCase())
      );
      setFilteredBusinesses(filtered);
      setShowSuggestions(filtered.length > 0);
    } else {
      setShowSuggestions(false);
      setFilteredBusinesses([]);
    }
  }, [newBusinessId, businesses]);

  const handleAddBusinessId = (businessId = null) => {
    console.log('handleAddBusinessId');

    const idToAdd = businessId || newBusinessId.trim();
    if (idToAdd) {
      console.log('idToAdd');
      console.log(idToAdd);

      setNewBusinessId('');
      setShowSuggestions(false);
    }
  };
  const handleSuggestionClick = (business) => {
    console.log('handleSuggestionClick');
    console.log(business);

    setNewBusinessId(business.business_id);
    setNewBusinessName(business.name);
    setShowSuggestions(false);
  };
  return (
    <div
      style={{
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        gap: 8,
      }}
    >
      <input
        value={newBusinessId}
        onChange={(e) => setNewBusinessId(e.target.value)}
        onFocus={() =>
          newBusinessId.trim() &&
          setShowSuggestions(filteredBusinesses.length > 0)
        }
        onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
        placeholder="Syötä y.tunnus…"
        style={{
          width: '100%',
          padding: '10px 12px',
          borderRadius: 10,
          border: '1px solid rgba(255,255,255,0.15)',
          background: 'rgba(255,255,255,0.06)',
          color: '#fff',
          outline: 'none',
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleAddBusinessId();
          }
          if (e.key === 'Escape') {
            setShowSuggestions(false);
          }
        }}
      />
      <p>Kirjoita ja valitse yritys</p>
      {/* Suggestions Dropdown */}
      {showSuggestions && filteredBusinesses.length > 0 && (
        <SuggestionFieldChatbot
          props={{ filteredBusinesses, handleSuggestionClick }}
        ></SuggestionFieldChatbot>
      )}

      <input
        value={businessName}
        onChange={(e) => setNewBusinessName(e.target.value)}
        placeholder="Syötä yrityksen nimi"
        style={{
          width: '100%',
          padding: '10px 12px',
          borderRadius: 10,
          border: '1px solid rgba(255,255,255,0.15)',
          background: 'rgba(255,255,255,0.06)',
          color: '#fff',
          outline: 'none',
        }}
      />
    </div>
  );
};
